<template>
  <div class="g-firstPage">
    <img :src='"../../assets/tongwei/"+data.data.tag+".png"' alt="" class="g-logo" v-if="data.newspaper_info.n_type == 1"/>
    <img :src='data.newspaper_info.head_img' alt="" class="g-logo" v-else/>
    <!-- <img src="../assets/8after.png" alt class="u-8after" /> -->
    <ul class="m-msgList" v-if="data.newspaper_info.n_type == 1">
      <li>
        <span>{{ data.time.date }}{{data.time.weekday}} </span>
      </li>
      <li :class="data.data.tag == '高效组件 通威智造'?'small':''">
        <span>{{data.data.website_url}}</span>
      </li>
      <li :class="data.data.tag == '高效组件 通威智造'?'small':''">
        <span>{{data.data.tag}}</span>
      </li>
    </ul>
  </div>
</template>
<script >
export default {
  name: "Twtop",
  props: {
    data: Object,
    time:Object,
    newspaper_info:Object
  },
  data(){
      return {
          location:{
              通威集团:'WWW.TONGWEI.COM',
              通威农牧:'WWW.TONGWEI.COM.CN',
              通威太阳能:'WWW.TW-SOLAR.COM',
              永祥股份:'WWW.SCYXGF.COM',
              通威新能源:'WWW.TW-NEWENERGY.COM',
              好主人宠物食品:'WWW.CARE-PET.COM',
          }
      }
  },
  computed: {
    gettime: function () {
      // `this` 指向 vm 实例
      let myDate = new Date();
      let year = myDate.getFullYear() + "年";
      let m = this.data.time_module.date.split(".");
      return year + m[0] + "月" + m[1] + "日";
    },
  },
  mounted(){

  }
};
</script>
<style lang='scss' scoped>
.g-firstPage {
  overflow: hidden;
  width: 100%;
  display: block;
  flex-shrink: 0;
}
.g-logo {
  // width: 9.36rem;
  // height:2.48rem;
  max-width: 100%;
  display: block;
}
.m-msgList {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #dc3a1b;
  display: flex;
  li {
    float: left;
    text-align: center;
    list-style: none;
    height: 0.533333rem;
    line-height: 0.533333rem;
    text-align: center;
    color: #fff;
    font-size: 0.24rem;
    overflow: hidden;
    word-break: keep-all;

    &:first-child {
    width: 2.746667rem;
    border-style: solid;
    border-width: 0px 1px 0px 0px;
    border-color: #ed9d8d;
    font-size: .2rem;
    //   span {
    //     transform: scale(0.8);
    //     transform-origin: 0.3rem 0.25rem;
    //     display: block;
    //   }
    }
    &:nth-child(2) {
      width: 3.5rem;
         border-style: solid;
        border-width: 0px 1px 0px 0px;
        border-color: #ed9d8d;
        white-space: nowrap;
    //   span {
    //     transform: scale(0.7);
    //     transform-origin: 0.8rem 0.25rem;
    //     display: block;
    //   }
    &.small {
      width: 3rem;
    }
    }
    &:last-child {
      width: 2rem;
    //    span {
    //     transform: scale(0.8);
    //     transform-origin: 0.8rem 0.25rem;
    //     display: block;
    //   }

      &.small {
        width: 2.5rem;
       
        white-space: nowrap;
      }

    }
  }
}
</style>